import React, { useLayoutEffect } from "react";
import { Redirect } from "react-router";
import { useDispatch, useStore } from "react-redux";
import { useParams } from "react-router-dom";

import {setCartAddressHouseDeliverySpot} from "../components/cart/_core/cartActions";
import { ROUTES } from "../system/router/routeConstants";

export function RefUpdateAddressPage() {
  const { house_id: houseId } = useParams();
  const dispatch = useDispatch();
  const store = useStore();

  useLayoutEffect(() => {
    if (!houseId) {
      return;
    }

    const payload = { house_delivery_spot_id: houseId };

    dispatch(setCartAddressHouseDeliverySpot(payload));
  }, [houseId, dispatch, store]);

  return (
    <Redirect
      to={{
        pathname: ROUTES.main.path,
        hash: "",
      }}
    />
  );
}
